module.exports = __webpack_public_path__ + "img/general-meter-water-meter-hot-lg.0634d727.svg";